import { t } from "@/i18n-js/instance";
import { useSupportWidgetContext } from "@circle-react/components/SupportWidget/SupportWidgetContext";
import { Typography } from "@circle-react-uikit/Typography";
import { useBillingContext } from "./BillingContext";
import { CancellationTypeformButton } from "./CancellationTypeformButton";

const localeRoot = "settings.billing.manage_billing.cancellation";

export const Cancellation = () => {
  const { currentPlan } = useBillingContext();
  const { toggleWidget } = useSupportWidgetContext() as {
    toggleWidget: (options?: { shouldTriggerOnWidgetClose?: boolean }) => void;
  };

  const cancellingMetadata = currentPlan?.cancelling_metadata;

  if (!cancellingMetadata) return null;

  return (
    <div className="my-4 flex flex-col gap-y-1">
      <Typography.LabelMd weight="semibold">
        {t(`${localeRoot}.title`)}
      </Typography.LabelMd>
      <Typography.BodySm color="text-default">
        {t(`${localeRoot}.description.you_can`)}
        <CancellationTypeformButton cancellingMetadata={cancellingMetadata} />
        {t(`${localeRoot}.description.any_time`)}
        <button
          type="button"
          onClick={() => toggleWidget()}
          className="underline"
        >
          {t(`${localeRoot}.description.contact_us`)}
        </button>{" "}
        {t(`${localeRoot}.description.for_support`)}
      </Typography.BodySm>
    </div>
  );
};
